import React, { useEffect } from "react";
import "../Popup/index.scss";
import { useState } from "react";
import { useLazyGetTutorialQuery } from "../../Store/Builder/dashboard.api";
import { useDispatch } from "react-redux";
import { setLoader } from "../../Store/Slice/techsbookSlice";

export default function OnboardingModal() {
  const dispatch = useDispatch();
  const [getTutorial] = useLazyGetTutorialQuery();
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVideo, setModalVideo] = useState(null);

  function extractVideoCode(url) {
    const matches = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (matches && matches.length > 1) {
      return matches[1];
    } else {
      // Вернуть пустую строку или другое значение по умолчанию, если не найдено совпадение.
      return "";
    }
  }

  const tutorial = () => {
    dispatch(setLoader(true));
    getTutorial()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        let video = extractVideoCode(res?.url);
        setModalVideo(video);
      })
      .catch((err) => {
        dispatch(setLoader(false));
      });
  };

  useEffect(() => {
    tutorial();
  }, []);

  return (
    <>
      {modalStatus === false ? (
        <div className="onboarding__modal">
          <div className="onboarding__modal-content">
            <div className="onboarding__modal-video">
              <iframe
                width="100%"
                height="100%"
                src={`https://youtube.com/embed/${modalVideo}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="onboarding__modal-block">
              <div className="onboarding__modal-title">
                Welcome to Techsbook!
              </div>
              <div className="onboarding__modal-descr">
                Where you’re in full control to book the technicians you want
                when you want them!
              </div>
              <div
                className="onboarding__modal-button"
                onClick={() => {
                  setModalStatus(true);
                }}
              >
                Continue
              </div>
            </div>
          </div>
          <div className="onboarding__modal-bg"></div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}
